import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PwaService } from 'src/app/_utils/pwa/pwa.service';
import { MENU } from 'src/app/app.config';

@Component({
  selector: 'app-bottombar',
  templateUrl: './bottombar.component.html',
  styleUrl: './bottombar.component.scss',
})
export class BottombarComponent implements OnInit {
  currentLocation: Subscription | null = null;
  menu: any[] = [];
  uid: string = '';

  espositori: any = {
    path: '/espositori',
    paths: ['espositori', 'espositore'],
    icon: 'map',
  };

  eventi: any = {
    path: '/evento/1',
    paths: ['eventi', 'evento'],
    icon: 'map',
  };

  //TODO aggiungere meu bottom eventi

  constructor(
    private router: Router,
    protected pwaService: PwaService,
    protected activatedRoute: ActivatedRoute
  ) {
    MENU.forEach((menuItem: any) => {
      this.menu.push({
        active: false,
        ...menuItem,
      });
    });

    this.activatedRoute.params.subscribe((params) => {
      if (params['uid']) {
        this.uid = params['uid'];
      }
    });
  }

  ngOnInit(): void {
    this.currentLocation = this.router.events.subscribe((val: any) => {
      this.menu.forEach((menuItem: any) => {
        menuItem.active = false;

        if (menuItem.paths) {
          if (
            menuItem.paths.includes(
              val.routerEvent?.urlAfterRedirects?.split('/')?.[1]
            ) ||
            menuItem.paths.includes(val.routerEvent?.url?.split('/')?.[1]) ||
            menuItem.paths.includes(
              val.routerEvent?.urlAfterRedirects
                ?.replace('/' + this.uid, '')
                .split('/')?.[1]
            ) ||
            menuItem.paths.includes(
              val.routerEvent?.url?.replace('/' + this.uid, '').split('/')?.[1]
            )
          ) {
            menuItem.active = true;
          }
        } else if (
          menuItem.path &&
          (val.routerEvent?.urlAfterRedirects == menuItem.path ||
            val.routerEvent?.url == menuItem.path ||
            val.routerEvent?.url.replace(this.uid, '') == menuItem.path ||
            val.routerEvent?.url.replace('/' + this.uid, '') == menuItem.path)
        ) {
          menuItem.active = true;
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.currentLocation?.unsubscribe();
  }

  goTo(location: string): void {
    this.router.navigate([location]);
  }
}
